/* this file is transformed by vux-loader */
/* eslint-disable */
import http from '../axios';

// 预约单基本信息：默认地址、模板信息等
export var apieventbashinfo = function apieventbashinfo() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'get';
  return http.request({
    url: '/event/bashInfo',
    method: method,
    params: method === 'get' || method === 'delete' ? query : {},
    data: method === 'post' || method === 'put' ? query : {}
  });
};
export var apieventsave = function apieventsave() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'get';
  return http.request({
    url: '/event/save',
    method: method,
    params: method === 'get' || method === 'delete' ? query : {},
    data: method === 'post' || method === 'put' ? query : {}
  });
};
export var apieventdetail = function apieventdetail() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'get';
  return http.request({
    url: '/event/detail',
    method: method,
    params: method === 'get' || method === 'delete' ? query : {},
    data: method === 'post' || method === 'put' ? query : {}
  });
};
export var apieventcancel = function apieventcancel() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'get';
  return http.request({
    url: '/event/cancel',
    method: method,
    params: method === 'get' || method === 'delete' ? query : {},
    data: method === 'post' || method === 'put' ? query : {}
  });
};
export var apieventmes = function apieventmes() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'get';
  return http.request({
    url: '/event/message/save',
    method: method,
    params: method === 'get' || method === 'delete' ? query : {},
    data: method === 'post' || method === 'put' ? query : {}
  });
};
export var apieventmeslist = function apieventmeslist() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'get';
  return http.request({
    url: '/event/message/list',
    method: method,
    params: method === 'get' || method === 'delete' ? query : {},
    data: method === 'post' || method === 'put' ? query : {}
  });
};
export var apieventevalbashInfo = function apieventevalbashInfo() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'get';
  return http.request({
    url: '/event/eval/bashInfo',
    method: method,
    params: method === 'get' || method === 'delete' ? query : {},
    data: method === 'post' || method === 'put' ? query : {}
  });
};
export var apieventevalsave = function apieventevalsave() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'get';
  return http.request({
    url: '/event/eval/save',
    method: method,
    params: method === 'get' || method === 'delete' ? query : {},
    data: method === 'post' || method === 'put' ? query : {}
  });
};
export var apieventevaldetail = function apieventevaldetail() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'get';
  return http.request({
    url: '/event/eval/detail',
    method: method,
    params: method === 'get' || method === 'delete' ? query : {},
    data: method === 'post' || method === 'put' ? query : {}
  });
};
export function getEventDetailCtrlList(data) {
  return http.request({
    url: '/obj/detailcontrol/objDetailControllerList',
    method: 'get',
    params: data
  });
}
export function getEventDetailCtrlFieldColumn(data) {
  return http.request({
    url: "/obj/detailcontrol/event/fieldValues",
    method: 'get',
    params: data
  });
}
export function newEventDetailCtrlForm(data) {
  return http.request({
    url: "/obj/detailcontrol/event/saveField",
    method: 'post',
    data: data
  });
}
export function saveEventDetailCtrlForm(data) {
  return http.request({
    url: '/obj/detailcontrol/event/updateField',
    method: 'post',
    data: data
  });
}
export function deleteEventDetailCtrlTableList(data) {
  return http.request({
    url: "/obj/detailcontrol/event/delete",
    method: 'delete',
    params: data
  });
}
export function getCustomerProductDetail(data) {
  return http.request({
    url: '/customer/product/detail',
    method: 'get',
    params: data
  });
}
export function getBreakdownPatternTypeList(data) {
  return http.request({
    url: '/breakdown/pattern/type/list',
    method: 'get',
    params: data
  });
}
export function getBreakdownPatternList(data) {
  return http.request({
    url: '/breakdown/pattern/list',
    method: 'get',
    params: data
  });
}

/**
 * 产品自定义字段显示
 * @param {} data
 * @returns
 */
export function getCustomerProductionService(data) {
  return http.request({
    url: '/customer/production/getService',
    method: 'get',
    params: data
  });
}
export function getV2ObjectCustomerProductionAppList(data) {
  return http.request({
    url: '/object/customer/production/order/list',
    method: 'get',
    params: data
  });
}